import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mc0102',
    ecrans: ['00-2'],
    params: [ '?doccleintref' ]
});
